import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";
import { insightDetailRoute } from "../../../config/insightDetails.js";

function renderCard(item, index) {
  const href = item.href || (item.slug ? insightDetailRoute(item.slug) : "#");
  const accent = item.accent || "#6c8cff";
  const indexLabel = String((index % 99) + 1).padStart(2, "0");

  return `
    <a
      class="services-insight"
      href="${href}"
      style="--card-i: ${index}; --insight-accent: ${accent}"
      aria-label="Read insight: ${item.title}"
    >
      <div class="services-insight__media" aria-hidden="true">
        <span class="services-insight__index">${indexLabel}</span>
        <span class="services-insight__orbit"></span>
        <span class="services-insight__orbit services-insight__orbit--b"></span>
      </div>
      <div class="services-insight__body">
        <div class="services-insight__meta">
          <span class="services-insight__category">${item.category}</span>
          <span class="services-insight__time">${item.readTime}</span>
        </div>
        <h3 class="services-insight__title">${item.title}</h3>
        <p class="services-insight__excerpt">${item.excerpt}</p>
        <span class="services-insight__more">
          Open insight
          <span aria-hidden="true">→</span>
        </span>
      </div>
    </a>
  `;
}

function renderGroup(items, { hidden = false } = {}) {
  return `
    <div class="services-insights__group"${hidden ? ' aria-hidden="true"' : ""}>
      ${items.map(renderCard).join("")}
    </div>
  `;
}

/** Repeat items so the marquee feels full even with a short list. */
function buildMarqueeItems(items) {
  if (!items.length) return [];
  const out = [...items];
  let i = 0;
  while (out.length < 6) {
    out.push(items[i % items.length]);
    i += 1;
  }
  return out;
}

export function createServicesInsightsSection(insights) {
  const section = document.createElement("section");
  section.id = "insights";
  section.className = "section services-insights";

  const marqueeItems = buildMarqueeItems(insights.items || []);

  section.innerHTML = `
    <div class="section__inner">
      <header class="section__header reveal">
        ${buildSectionPillRow(insights.badge)}
        <h2>${buildAnimatedHeading(insights.titleSegments)}</h2>
        <p>${insights.subtitle}</p>
      </header>
    </div>

    <div class="services-insights__marquee reveal" style="--delay: 0.12s">
      <div class="services-insights__viewport">
        <div class="services-insights__track">
          ${renderGroup(marqueeItems)}
          ${renderGroup(marqueeItems, { hidden: true })}
        </div>
      </div>
    </div>
  `;

  return section;
}
